exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media only screen and (min-width:992px){.table{display:table}.table .testimonial-icon-valid-true{color:green;font-size:25px}.table .testimonial-icon-valid-false{color:red;font-size:25px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fb3d1ba","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/testimonial/List.vue
// module id = 953
// module chunks = 0